import { type IModel, type IAttribute, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';

import { KustoLinkedService } from 'app/model/linkedservice/kusto.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.kustoActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Kusto_DisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Kusto_DisplayText)
    ]
})
export class KustoActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly DATABASE: IAttribute;
    public static readonly COMMAND: IAttribute;
    public static readonly COMMAND_TYPE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database,
        constraint: {
            required: true
        },
        association: 'DATABASE',
        templatable: true
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Command,
        constraint: {
            required: true
        },
        association: 'COMMAND',
        templatable: true
    })
    public command?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CommandType,
        association: 'COMMAND_TYPE',
        templatable: true
    })
    public commandType?: string = 'Control';

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Kusto_DisplayText),
        constraint: {
            required: true
        },
        reference: true,
        type: KustoLinkedService.MODEL
    })
    public linkedService?: KustoLinkedService;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }
}
